import { html } from 'lit';
import { Pin } from 'lucide-static';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { state } from 'lit/decorators.js';
import { pdsCustomIconElement as customElement } from '../../../decorators/pds-icon';
import { PdsIcon } from '../PdsIcon';

@customElement('pds-icon-pin')
export class PdsIconPin extends PdsIcon {
  @state()
  icon = Pin;

  render() {
    return html`${unsafeHTML(this.setIconAttributes())}`;
  }
}
